var React = require('react');

function IconExtern (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"extern"),React.createElement("path",{"d":"M70.38,27.67H55.81a2,2,0,0,0-1.34.61,1.93,1.93,0,0,0-.54,1.39,2,2,0,0,0,1.92,1.9h9.82L47.18,50.06a1.94,1.94,0,0,0,1.38,3.32,2,2,0,0,0,1.38-.56L68.43,34.33v9.85a2,2,0,0,0,.6,1.35,1.87,1.87,0,0,0,1.4.54,2,2,0,0,0,1.9-1.91V29.62A2,2,0,0,0,70.38,27.67Z","key":1}),React.createElement("path",{"d":"M63.71,46.92a2.11,2.11,0,0,0-2.1,2.1V68.14H31.86V38.39H51a2.1,2.1,0,0,0,2.16-2,2.09,2.09,0,0,0-2.06-2.14H29.77a2.11,2.11,0,0,0-2.1,2.09V70.23a2.1,2.1,0,0,0,2.1,2.1H63.71a2.1,2.1,0,0,0,2.1-2.1V49A2.1,2.1,0,0,0,63.71,46.92Z","key":2})]);
}

IconExtern.displayName = "IconExtern";

IconExtern.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 100 100"};

module.exports = IconExtern;

IconExtern.default = IconExtern;
